import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppSettingsService {
	private settings: any = null;

	constructor(private http: HttpClient) {}

	async load(): Promise<void> {
		const url = '/assets/configs/app-settings.json';
		const s = await firstValueFrom(this.http.get(url));
		this.settings = s as any;
	}

	get apiBaseUrl(): string | undefined {
		return this.settings?.apiBaseUrl;
	}

	get<T = any>(key: string): T | undefined {
		return this.settings ? (this.settings[key] as T) : undefined;
	}
}
